<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import BroadcastCreate from '../../../../broadcasts/components/BroadcastCreate.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})
</script>

<template>
  <BroadcastCreate />
</template>